import { render, staticRenderFns } from "./ProcesoForm.vue?vue&type=template&id=467cec7f&scoped=true"
import script from "./ProcesoForm.vue?vue&type=script&lang=js"
export * from "./ProcesoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467cec7f",
  null
  
)

export default component.exports